import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import PrivacyControl from "./PrivacyControl";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, consentTextNode, consentText, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("Form.PrivacyControl");
            consentTextNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "consent"
            })));
            _context.next = 4;
            return rehydrateChildren(consentTextNode);

          case 4:
            consentText = _context.sent;
            props = {
              compliantCountries: JSON.parse(domNode.getAttribute("data-compliant-countries")),
              consentName: domNode.getAttribute("data-consent-name"),
              consentText: consentText,
              dependsOn: domNode.getAttribute("data-depends-on"),
              explicitConsentId: domNode.getAttribute("data-explicit-consent-id"),
              explicitConsentText: domNode.getAttribute("data-explicit-consent-text"),
              isRehydrating: true
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(PrivacyControl, props));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();